export default "__VITE_ASSET__d0bd0a9b__"